import { Fragment } from 'react'

import { Dialog, Transition } from '@headlessui/react'

interface AskUserConfirmationProps {
  children?: React.ReactNode
  openDialog: boolean
  onClose: () => void
}

const AskUserConfirmation = ({
  children,
  openDialog,
  onClose,
}: AskUserConfirmationProps) => (
  <div>
    <Transition
      as={Dialog}
      show={openDialog}
      onClose={onClose}
      className="relative"
      style={{ zIndex: 99999 }}
    >
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-opacity-0" />
      </Transition.Child>

      <div className="fixed inset-0 w-screen">
        <div className="flex items-end justify-center min-h-full text-center sm:items-center sm:p-6">
          <Transition.Child
            as={Fragment}
            enter="transform transition duration-500 ease-in-out sm:duration-300 sm:ease-out"
            enterFrom="translate-y-full sm:opacity-0 sm:translate-y-0 sm:scale-95"
            enterTo="translate-y-0 sm:opacity-100 sm:scale-100"
            leave="transform transition duration-500 ease-in-out sm:duration-200 sm:ease-in"
            leaveFrom="opacity-100 translate-y-0 sm:translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-full sm:translate-y-0 sm:scale-95"
          >
            {children}
          </Transition.Child>
        </div>
      </div>
    </Transition>
  </div>
)

export default AskUserConfirmation
